<cache-date></cache-date>

<period></period>


<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<hr/>

<chart [data]="chartData.data" [options]="chartData.options" (onFilterChange)="updateData($event)" [sextant]="'chart'" [url]="filter.currentUrl"></chart>

<hr>

<loading [isLoad]="totalLoader"></loading>
<div *ngIf="!totalLoader && total" [sextant]="'totalTable'" [url]="filter.currentUrl">
	<ngb-accordion #acc="ngbAccordion">
		<ngb-panel title="Total" [id]="'total'">
			<ng-template ngbPanelContent>
				<div class="col-md-12">
					<table class="table js-domain-billing-total" data-period="<%= params.period %>">
						<thead>
							<tr>
								<th></th>
								<th>{{ 'adminstat.billing.domain_billing.paid Count' | translate }}</th>
								<th>{{ 'adminstat.common.Currency' | translate }}</th>
								<th>{{ 'adminstat.billing.domain_billing.domain Count' | translate }}</th>
								<th>{{ 'adminstat.common.Money' | translate }}</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let currency of ['usd']; let i = index">
								<td>
									<ng-container *ngIf="i == 0">{{ 'adminstat.common.All count' | translate }}</ng-container>
								</td>
								
								<td [sextant]="'totalCount'" [url]="filter.currentUrl">
									{{ total.total[currency] ? total.total[currency].paidCount : 0 }}
								</td>
								
								<td>
									{{ helper.currencyLabels[currency] }}
								</td>
								
								<td>
									{{ total.total[currency] ? total.total[currency].domainCount : 0 }}
								</td>
								
								<td>
									{{ total.total[currency] ? helper.convertAmountToDollar(total.total[currency].moneyCount, currency) : 0 }}
								</td>
							</tr>
							
							<tr *ngFor="let currency of currencyList; let i = index">
								<td>
									<ng-container *ngIf="i == 0">{{ 'adminstat.common.In query count' | translate }}</ng-container>
								</td>
								
								<td>
									{{ total.query[currency] ? total.query[currency].paidCount : 0 }}
								</td>
								
								<td>
									{{ helper.currencyLabels[currency] }}
								</td>
								
								<td>
									{{ total.query[currency] ? total.query[currency].domainCount : 0 }}
								</td>
								
								<td>
									{{ total.query[currency] ? helper.convertAmountToDollar(total.query[currency].moneyCount, currency) : 0 }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</ng-template>
		</ngb-panel>
	</ngb-accordion>
</div>

<hr>

<loading [isLoad]="paginationLoader"></loading>
<ngb-pagination
	[extlinks]="links"
	[collectionSize]="pagination.pageCount"
	[maxSize]="10"
	[pageSize]="1"
	[(page)]="pagination.page"
	[boundaryLinks]="true"
	(pageChange)="onPageChange()"
	*ngIf="!paginationLoader && pagination.pageCount > 1"
></ngb-pagination>


<ref_status [stats]="stats"></ref_status>

<loading [isLoad]="statsLoader"></loading>
<table class="table table-bordered table-nonfluid" [sextant]="'stats'" [url]="filter.currentUrl">
	<thead>
		<tr>
			<th>
				{{ 'adminstat.common.Date' | translate }}
			</th>
			
			<th>
				{{ 'adminstat.common.Total info' | translate }}
			</th>
		</tr>
	</thead>

	<tbody>
		<tr *ngFor="let stat of stats">
			<td [class]="stat.day == 0 || stat.day == 6 ? 'table-info' : ''">
				{{ stat.currentPeriod }}
			</td>
			
			<td class="js-ul-billing-info">
				<table class="table">
					<thead>
						<tr>
							<th>
								{{ 'adminstat.common.Money' | translate }}
							</th>
							
							<th>
								{{ helper.convertAmountToDollar(stat.totalMoney, 'usd') }}
							</th>
						</tr>
					</thead>
				</table>
				
				<table class="table" *ngIf="stat.moneyMap">
					<thead>
						<tr>
							<th></th>
							<th *ngFor="let currency of currencyList" [innerHTML]="helper.currencyLabels[currency]"></th>
						</tr>
					</thead>
					
					<tbody>
						<tr *ngFor="let key of ['domainProlongation', 'buyDomain']">
							<td>
								{{ 'adminstat.billing.billing.' + key | translate }}
							</td>
							
							<td *ngFor="let currency of currencyList">
								<button-anhor *ngIf="stat.moneyMap && stat.moneyMap[key] && stat.moneyMap[key][currency] > 0; else domainBillingOther" (click)="showMoneyDetails(key, stat, currency)" class="js-ul-domain-billing-money-details" [attr.data-key]="key" [attr.data-currency]="currency">
									{{ stat.moneyMap[key][currency] }}
								</button-anhor>

								<ng-template #domainBillingOther>
									{{ stat.moneyMap && stat.moneyMap[key] && stat.moneyMap[key][currency] ? stat.moneyMap[key][currency] : 0 }}
								</ng-template>
							</td>
						</tr>
					</tbody>
				</table>
				
				
				<table class="table">
					<tr *ngFor="let key of ['paidCount', 'prolongationCount']">
						<td>
							{{ 'adminstat.billing.domain_billing.' + (key == 'prolongationCount' ? 'prolongationCount.title' : key) | translate }}
						</td>
						
						<td>
							<button-anhor *ngIf="stat[key] > 0; else domainBillingOther2" (click)="showDetails(key, stat)" class="js-ul-domain-billing-details" [attr.data-key]="key">
								{{ stat[key] }}
							</button-anhor>
							
							<ng-template #domainBillingOther2>
								0
							</ng-template>
						</td>
					</tr>
				</table>
				
				<refs [stats]="stat" [filterParams]="filter.filterParams" [currentUrl]="filter.currentUrl"></refs>
			</td>
		</tr>
	</tbody>
</table>
